export default [
  {
    path: '/standards',
    name: 'Standards',
    component: () => import('@/views/Standards/Index.vue'),
    redirect: { name: 'StandardsDecrees' },
    children: [
      {
        path: 'decrees',
        name: 'StandardsDecrees',
        component: () => import('@/views/Standards/StandardsDecrees.vue')
      },
      {
        path: 'decrees/:id_standards_decrees',
        name: 'StandardsDecreesUpdate',
        component: () => import('@/views/Standards/StandardsDecreesUpdate.vue')
      },
      {
        path: 'org-standards',
        name: 'StandardsOrgStandards',
        component: () => import('@/views/Standards/StandardsOrgStandards.vue')
      },
      {
        path: 'worker-folder',
        name: 'StandardsWorkerFolder',
        component: () => import('@/views/Standards/StandardsWorkerFolder.vue')
      },
      {
        path: 'jobs-folder',
        name: 'StandardsJobsFolder',
        component: () => import('@/views/Standards/StandardsJobsFolder.vue')
      }
    ]
  }
]
